import { Injectable } from '@angular/core';
import { ApplicantOptionalField } from '@app/models/recruiting/applicant-optional-field.model';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import { JobPostingOptionalField } from '../interfaces/optional-field.interface';

@Injectable()
export class ApplicantOptionalFieldService {
    fields: JobPostingOptionalField[];

    attachFieldsJobPosting(jobPosting: JobPosting, fields: JobPostingOptionalField[]): void {
        fields.forEach((field: JobPostingOptionalField) => {
            if (!field.checked && !field.disabled && !this.existsInOptionalFields(jobPosting, field)) {
                jobPosting.attach('applicantOptionalFieldTypes', [field.typeId]);
            }
        });
    }

    detachFieldsJobPosting(jobPosting: JobPosting, fields: JobPostingOptionalField[]): void {
        fields.forEach((field: JobPostingOptionalField) => {
            if (field.checked && !field.disabled && this.existsInOptionalFields(jobPosting, field)) {
                jobPosting.detach('applicantOptionalFieldTypes', [field.typeId]);
            }
        });
    }

    existsInOptionalFields(jobPosting: JobPosting, field: JobPostingOptionalField): boolean {
        const exists = jobPosting.applicantOptionalFields.some((applicantField: ApplicantOptionalField) => {
            return applicantField.fieldName == field.name;
        });

        return exists;
    }

    attachAndDetachToJobPosting(jobPosting: JobPosting, fields: JobPostingOptionalField[]): void {
        if (!jobPosting) {
            return;
        }

        jobPosting.clearAttach();
        jobPosting.clearDetach();

        this.attachFieldsJobPosting(jobPosting, fields);
        this.detachFieldsJobPosting(jobPosting, fields);
    }
}
